import useAdminLoad from "@/hooks/useAdminLoad";
import { LoadState, Panel } from "@/components/admin/AdminUI";
import { CodesTable } from "@/components/admin/launch/InviteCodesTab";

function Stat({ label, value, testId }) {
  return <Panel className="p-5" data-testid={testId}><p className="cw-soft text-sm">{label}</p><p className="mt-2 text-3xl font-semibold tabular-nums">{value ?? 0}</p></Panel>;
}

export default function ReferralsTab() {
  const stats = useAdminLoad("/admin/launch");
  const list = useAdminLoad("/admin/invite-codes?kind=referral");
  const r = stats.data?.referrals;
  return (
    <div className="space-y-6" data-testid="launch-referrals-tab">
      <LoadState loading={stats.loading} error={stats.error} onRetry={stats.reload}>
        <div className="grid gap-4 sm:grid-cols-3">
          <Stat label="Codes issued" value={r?.codes_issued} testId="referrals-issued" />
          <Stat label="Codes used" value={r?.codes_used} testId="referrals-used" />
          <Stat label="Rewards given (both people)" value={r?.rewards} testId="referrals-rewards" />
        </div>
      </LoadState>
      <LoadState loading={list.loading} error={list.error} onRetry={list.reload}>
        <Panel className="overflow-hidden">
          <p className="cw-muted border-b border-border px-5 py-3 text-xs">{list.data?.total ?? 0} referral codes · members get them after onboarding (Settings › Launch)</p>
          <CodesTable items={list.data?.items} testId="referral-codes-table" />
        </Panel>
      </LoadState>
    </div>
  );
}
